export const Dbs = {
    VERSION: 1,

    DB: 'Visitas/v3',

    COLLECTION_SESSION: 'session',
    COLLECTION_STATE: 'state',
    COLLECTION_TMP: 'tmp'
}
